export default __webpack_public_path__ + "static/media/elgreen-ele.3fdfd33f.png";